import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
// import Contactus from "./Contact";
import Domainpage from "./Dapa";
// import Seoinspect from "./Seoinspect";
import { Link } from "react-router-dom";
import Trialcards from "./Trial";
import Nav from "./Navbar";
import Main from "./Main";
import Footer from "./Footer";
import { FaCheck } from "react-icons/fa";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import ChatWidget from "./ChatBot";
import Ai from "./Ai";
// import Sitefaq from "./Sitefaq";
import Topconnection from "./Topconnection";
import LogoSlider from "./logopartner";
import Testimonials from "./Testonomial";
import { basicauth } from "../Utils/Credentials";
import SeoMeta from "../Seo/SeoMeta";
import { seoPages } from "../Seo/seoConfig";

const homeFaqs = [
  {
    question: "Is SeoBix free to use?",
    answer:
      "Yes, SeoBix offers a free plan with unlimited site audits, 10 ranking keywords, and 2,000 rows per month — a good starting point before upgrading.",
  },
  {
    question: "What's included in the free plan?",
    answer:
      "1 project, unlimited site audits, 10 ranking keywords, and core tools like link building, keyword research, and backlink analysis.",
  },
  {
    question: "How is SeoBix different from other tools?",
    answer:
      "SeoBix combines SEO and social media optimization in one platform at a lower starting price, with direct Google Search Console, Analytics, and Trends integration.",
  },
  {
    question: "Do I need a credit card to start the free trial?",
    answer:
      "No, you can start with the free plan without entering payment details.",
  },
  {
    question: "Does SeoBix support social media management too?",
    answer:
      "Yes, SeoBix includes SMO tools for Instagram, Facebook, and YouTube, plus content creation tools like post and reel creators.",
  },
  {
    question: "Can I track my Google rankings with SeoBix?",
    answer:
      "Yes, Bix Tracker monitors your keyword rankings and integrates with Google Search Console for accurate data.",
  },
  {
    question: "Does SeoBix offer a backlink analysis tool?",
    answer:
      "Yes, available from the free plan upward, check your backlink profile, spot spam links, and find new opportunities.",
  },
  {
    question: "Is SeoBix suitable for agencies managing multiple clients?",
    answer:
      "Yes, Standard and Premium plans support up to 15 projects and 500 ranking keywords, built for agencies.",
  },
  {
    question: "Can I check my domain authority for free with SeoBix?",
    answer:
      "Yes, the free Domain Authority Checker and Domain Age Checker are available to anyone.",
  },
  {
    question: "Does SeoBix help with structured data and schema markup?",
    answer:
      "Yes, SeoBix includes tools to add and check schema markup, helping your pages qualify for rich results.",
  },
];

const First = () => {


  return (
    <div>
      <SeoMeta page={seoPages["/"]} includeCanonical={false} />
      <Nav />
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        <Main />

      

        <Trialcards />
        <section
          className="py-5"
          style={{
            background:
              "linear-gradient(180deg, #FFFFFF 0%, #F5FBFF 48%, #FFFFFF 100%)",
          }}
        >
          <Row className="justify-content-center mx-1">
            <Col md={10}>
              <div
                className="p-4 p-md-5"
                style={{
                  background:
                    "linear-gradient(135deg, #090040 0%, #0A3981 54%, #0E7490 100%)",
                  border: "1px solid rgba(175, 221, 255, .28)",
                  borderRadius: "8px",
                  boxShadow: "0 24px 60px rgba(9, 0, 64, .18)",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <Row className="g-4 align-items-center">
                  <Col lg={5}>
                    <span
                      style={{
                        background: "rgba(175, 221, 255, .14)",
                        border: "1px solid rgba(175, 221, 255, .32)",
                        borderRadius: "999px",
                        color: "#AFDDFF",
                        display: "inline-flex",
                        fontSize: ".85rem",
                        fontWeight: 800,
                        padding: "8px 14px",
                      }}
                    >
                      SEO + SMO platform
                    </span>
                    <h2
                      className="mt-3 mb-3"
                      style={{
                        color: "#FFFFFF",
                        fontSize: "clamp(2.2rem, 4vw, 3.4rem)",
                        fontWeight: 800,
                        lineHeight: 1.08,
                      }}
                    >
                      Why choose SeoBix
                    </h2>
                    <p
                      className="mb-0"
                      style={{
                        color: "#DFF3FF",
                        fontSize: "1.08rem",
                        lineHeight: 1.8,
                      }}
                    >
                      A complete workspace for small businesses and agencies
                      that need SEO insights, ranking visibility, and social
                      media optimization in one place.
                    </p>
                  </Col>
                  <Col lg={7}>
                    <div
                      className="p-3 p-md-4"
                      style={{
                        background: "rgba(255, 255, 255, .96)",
                        border: "1px solid rgba(255, 255, 255, .7)",
                        borderRadius: "8px",
                      }}
                    >
                      <p
                        className="mb-4"
                        style={{
                          color: "#1f2a44",
                          fontSize: "1.05rem",
                          lineHeight: 1.8,
                        }}
                      >
                        SeoBix brings together every essential SEO and social
                        media tool small businesses and agencies need to grow
                        online, from website audits and keyword research to
                        backlink analysis, rank tracking, and structured data
                        management. Whether you're running SEO for a single
                        website or managing campaigns for multiple clients,
                        SeoBix's free and paid plans scale with you, combining
                        Google Search Console integration, competitor research,
                        and social media optimization in one dashboard.
                      </p>
                      <Row className="g-3">
                        {[
                          "Website audits, keywords, backlinks, and rank tracking",
                          "Google Search Console, Analytics, and Trends integration",
                          "SEO and social media optimization for growing teams",
                        ].map((point) => (
                          <Col md={4} key={point}>
                            <div
                              className="h-100 p-3"
                              style={{
                                background: "#F7FBFF",
                                border: "1px solid #DDEEFF",
                                borderRadius: "8px",
                              }}
                            >
                              <span
                                className="d-inline-flex align-items-center justify-content-center mb-3"
                                style={{
                                  background: "#EAF6FF",
                                  borderRadius: "8px",
                                  color: "#0A3981",
                                  height: "36px",
                                  width: "36px",
                                }}
                              >
                                <FaCheck />
                              </span>
                              <p
                                className="mb-0"
                                style={{
                                  color: "#090040",
                                  fontSize: ".95rem",
                                  fontWeight: 700,
                                  lineHeight: 1.5,
                                }}
                              >
                                {point}
                              </p>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </section>
        <div
          className="  p-4 "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            marginTop: "7rem",
          }}
        >
          <h2
            style={{ color: "#0A3981" }}
            className="d-flex justify-content-center pt-5"
          >
            <b> Check Your Domain Authority and Age Instantly</b>
          </h2>
          <Domainpage />
        </div>
        <Row
          className="pricing-section d-flex justify-content-center mx-0"
        >
          <Col xs={12} md={10} className="px-3 px-sm-4">
            <h2 className="pricing-section-title mt-2 mb-3 text-center">
              <b>Plans & Pricing</b>
            </h2>
            <div className="text-center my-4">
              <p
                className="pricing-section-offer font-weight-bold mb-4"
              >
                🚀 Improve Your Rankings —{" "}
                <span style={{ color: "#B83200" }}>Try Our Service Free for 3 Months!</span>,
                Limited Time Only!
              </p>
              <a
                href="https://dashboard.seobix.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="pricing-section-cta"
              >
                Get Started For Free
              </a>
            </div>

            <Pricingcard />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Topconnection />
          </Col>
        </Row>

        <Ai />
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <LogoSlider />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-3 mb-2  mx-1">
          <Col md={10}>
            <Testimonials />
          </Col>
        </Row>
        <HomeFaqSection />
       
       
        {/* <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Sitefaq />
          </Col>
        </Row> */}
        {/* <Contactus /> */}

        <div
          data-section="Footer"
          className=" p-0 "
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
            marginTop: "6rem",
          }}
        >
          <Footer />
        </div>
      </Container>
      {/* <ChatWidget /> */}
    </div>
  );
};

const HomeFaqSection = () => (
  <section
    className="py-5"
    style={{
      background:
        "linear-gradient(180deg, #FFFFFF 0%, #F3FAFF 48%, #FFFFFF 100%)",
    }}
  >
    <Row className="justify-content-center mx-1">
      <Col md={10}>
        <div className="text-center mb-4">
          <span
            style={{
              background: "#EAF6FF",
              border: "1px solid #CFE7FF",
              borderRadius: "999px",
              color: "#0A3981",
              display: "inline-flex",
              fontSize: ".85rem",
              fontWeight: 800,
              padding: "8px 14px",
            }}
          >
            SeoBix FAQ
          </span>
          <h2
            className="mt-3 mb-2"
            style={{
              color: "#090040",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: 800,
            }}
          >
            Questions before you start?
          </h2>
          <p
            className="mx-auto mb-0"
            style={{ color: "#4b5563", fontSize: "1.05rem", maxWidth: "760px" }}
          >
            Learn what is included in SeoBix, how the free plan works, and how
            it supports SEO and social media workflows.
          </p>
        </div>
        <Row className="justify-content-center">
          <Col lg={9}>
            <div
              className="p-3 p-md-4"
              style={{
                background: "#FFFFFF",
                border: "1px solid #DDEEFF",
                borderRadius: "8px",
                boxShadow: "0 18px 45px rgba(9, 0, 64, .08)",
              }}
            >
              <Accordion defaultActiveKey="0" flush>
              {homeFaqs.map((faq, index) => (
                <Accordion.Item eventKey={`${index}`} key={faq.question}>
                  <Accordion.Header>{faq.question}</Accordion.Header>
                  <Accordion.Body>{faq.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
              </Accordion>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </section>
);

const toNumber = (val) => {
  if (val == null) return 0;
  if (typeof val === "number") return val;
  if (typeof val === "string") {
    const cleaned = val.replace(/[^0-9.]/g, "");
    const parsed = parseFloat(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const formatMoney = (amount, currencyCode) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 2,
  }).format(amount);

const Pricingcard = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("USD");
  const [billingCycle, setBillingCycle] = useState("monthly"); // 👈 NEW
  const USD_TO_INR = 87;


  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const GetPricingPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Setting/GetPricingPlans`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );
  
      if (!response.ok) throw new Error("Failed to fetch SEO data.");
  
      const data = await response.json();
  
      if (data.status === "0" && data.data) {
        const sortedPlans = [...data.data].sort((a, b) => {
          if (a.identity === "4") return -1;
          if (b.identity === "4") return 1;
          return parseInt(a.identity) - parseInt(b.identity);
        });
  
        const formattedPlans = sortedPlans.map((plan) => ({
          name: plan.plan_name,
          priceUSD: toNumber(plan.amount),
          duration: plan.duration, 
          description: plan.desc1,
          features1: plan.features1,
          features2: plan.features2,
          features3: plan.features3,
          features4: plan.features4,
          heading: plan.heading,
          desc2: plan.desc2,
          features: Array.isArray(plan.data)
            ? plan.data.map((feature) => ({
                text: feature.description,
                video: feature.video_url || null,
              }))
            : [],
          buttonText: "Start Now",
        }));
  
        setPlans(formattedPlans);
      } else {
        setPlans([]);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    GetPricingPlans();
  }, []);
  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix"  decoding="async"/>
        </div>
      ) : (
        <>
          {/* Switchers */}
          <div className="pricing-switchers d-flex flex-column flex-lg-row justify-content-center align-items-center gap-3 gap-lg-4 mb-4">
         
            <div className="pricing-switcher d-flex justify-content-center align-items-center gap-2">
              <span className="fw-semibold">USD</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="currencySwitch"
                  aria-label="Switch between USD and INR"
                  checked={currency === "INR"}
                  onChange={(e) =>
                    setCurrency(e.target.checked ? "INR" : "USD")
                  }
                />
              </div>
              <span className="fw-semibold">INR</span>
            </div>

            <div className="pricing-switcher d-flex justify-content-center align-items-center gap-2">
              <span className="fw-semibold">Monthly</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="billingSwitch"
                  aria-label="Switch between monthly and yearly billing"
                  checked={billingCycle === "yearly"}
                  onChange={(e) =>
                    setBillingCycle(e.target.checked ? "yearly" : "monthly")
                  }
                />
              </div>
              <span className="fw-semibold">Yearly</span>
            </div>
          </div>

          {/* Pricing Cards */}
          <Row className="justify-content-center mx-1">
            {plans.map((plan, index) => {
              let base = plan.priceUSD; // numeric

              // 💡 Apply yearly multiplier (12x) if yearly selected
              if (billingCycle === "yearly") {
                base = base * 12;
              }

              const amount = currency === "USD" ? base : base * USD_TO_INR;
              const displayPrice = formatMoney(amount, currency);

              return (
                <Col key={index} md={6} lg={3} className="mb-4">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="p-3">
                      <p className="mb-1 h5">
                        <b>{plan.name}</b>
                      </p>
                      <p className="h3">
                        <b>{displayPrice}</b>/
                        <span style={{ fontSize: "1rem" }}>
                          {billingCycle === "yearly" ? "year" : plan.duration}
                        </span>
                      </p>
                      <Link
                        onClick={() =>
                          window.open("https://dashboard.seobix.com/", "_blank")
                        }
                        style={{ textDecoration: "none", color: "#fff" }}
                      >
                        <Button className="mt-2 mb-2" style={{ width: "100%" }}>
                          {plan.buttonText}
                        </Button>
                      </Link>

                      <p className="text-muted mb-2 mt-3">
                        <b>{plan.description}</b>
                      </p>

                      {plan.features1 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features1}
                        </p>
                      )}
                      {plan.features2 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features2}
                        </p>
                      )}
                      {plan.features3 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features3}
                        </p>
                      )}
                      {plan.features4 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features4}
                        </p>
                      )}

                      {plan.heading && (
                        <p className="h6">
                          <b>{plan.heading}</b>
                        </p>
                      )}
                      {plan.desc2 && (
                        <p
                          className="text-muted mb-2 mt-3"
                          style={{ fontWeight: "500" }}
                        >
                          {plan.desc2}
                        </p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </>
  );
};

export default First;
